/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { typography2 } from '@coursera/cds-core';

import type { DdpFieldsAboveFoldFragment } from 'bundles/degree-description/__generated__/contentfulTypes';
import RichText from 'bundles/degree-description/components/shared/RichText';
import { useDegreeDescriptionPageTheme } from 'bundles/degree-description/degreeDescriptionPageTheme';
import type { DegreeDescriptionPageTheme } from 'bundles/degree-description/degreeDescriptionPageTheme';

const styles = {
  bannerStyles: (theme: DegreeDescriptionPageTheme) => css`
    background-color: var(--cds-color-blue-900);
    width: 100%;

    .rc-RichText {
      p {
        ${typography2.bodyPrimary};
        color: var(--cds-color-neutral-primary-invert);
        margin: 0;
        padding: var(--cds-spacing-150);
        text-align: center;
        ${theme.mobileFontSizeStyle?.body};
      }

      a,
      a:visited:not(.cds-link-focusVisible) {
        ${typography2.bodyPrimary};
        color: var(--cds-color-neutral-primary-invert);
        text-decoration: underline;
        ${theme.mobileFontSizeStyle?.body};

        &:hover,
        &:focus {
          text-decoration: none;
        }
      }
    }
  `,
};

type Props = {
  bannerContent?: DdpFieldsAboveFoldFragment['bannerNotification'];
};

const TopBanner = ({ bannerContent }: Props) => {
  const theme = useDegreeDescriptionPageTheme();
  if (!bannerContent) return null;
  return (
    <div className="rc-TopBanner" css={styles.bannerStyles(theme)}>
      <RichText
        content={bannerContent.json}
        linkTrackingName="top_banner"
        buttonTrackingNameV3="degree_top_banner_link"
        trackingSection="hero_banner"
      />
    </div>
  );
};

export default TopBanner;
